
function MBProgressBar() {
  this.progressBarWrapper = document.getElementById("progress-bar-wrapper");
  this.currentPriceWrapper = document.getElementById("total-price");
  this.maxPrice = parseInt(this.progressBarWrapper.getAttribute("data-max-price"));
  this.currentPrice = parseInt(this.currentPriceWrapper.getAttribute("data-current-price"));
  this.priceLabel = document.querySelector(".mb-cart__progress-label-price");

  this.iconImg = document.getElementById('progress-icon');
  this.svgPath = document.getElementById('progress-bar-path');

  this.path = null;
  this.lastPercent = 0;
}

MBProgressBar.prototype = {
  setup: function() {
    this.path = new ProgressBar.Path(this.svgPath, {
        duration: 1300,
        easing: 'easeInOut',
        step: function(state, bar, attachment) {
          let iconWidth = this.iconImg.getBoundingClientRect().width;
          let width = this.svgPath.getBoundingClientRect().width;
          let _position = (width - width * state.offset / 335) - iconWidth / 2;
          let position = Math.min(_position, width - iconWidth * 2 / 3); // Iconが右にはみ出ないように調整
          this.iconImg.style.left = position + "px";

          let percent = 1 - state.offset / 335;
          let changeModeTo = this.shouldChangeModeTo(percent);
          if (changeModeTo) {
            this.changeIconMode(changeModeTo);
          }

          this.lastPercent = percent;
        }.bind(this)
    });
  },

  animateToCurrent: function() {
    this.currentPrice = parseInt(this.currentPriceWrapper.getAttribute("data-current-price"));

    this.updateLabel();

    this.path.animate(
      Math.min(this.currentPrice / this.maxPrice, 1)
    );
  },

  updateLabel: function() {
    this.priceLabel.innerHTML = Math.max(this.maxPrice - this.currentPrice, 0);
  },

  shouldChangeModeTo: function(newPerent) {
    let threshold = 0.99999;
    if (this.lastPercent <= threshold && newPerent > threshold) {
      return "complete";
    }
    if (this.lastPercent > threshold && newPerent <= threshold) {
      return "decrease";
    }
    return null;
  },

  changeIconMode: function(mode) {
    let imgs = this.iconImg.querySelectorAll("img");
    Array.from(imgs).forEach(function(img) {
      img.style.display = "none";
    });

    let iconSelector;

    if (mode === "normal") {
      iconSelector = ".progress-icon-normal";
    }
    
    else if (mode === "complete") {
      iconSelector = ".progress-icon-complete";
    }

    else if (mode === "decrease") {
      iconSelector = ".progress-icon-decrease";
    }

    let img = this.iconImg.querySelector(iconSelector);
    img.style.display = "block";

    if (mode === "decrease") {
      setTimeout(function() {
        this.changeIconMode("normal");
      }.bind(this), 3000);
    }
  }
}
